import _ from "lodash";

const physicalEntityMapper = {
  /**
   * Map array of physical entities objects
   * @param {Array} physicalEntities
   * @return {Array}
   */
  mapPhysicalEntities: function (entities) {
    return entities.map((item) => {
      return this.mapPhysicalEntity(item);
    });
  },

  /**
   * Map physical entity object
   * @param {Object} physicalEntity
   * @return {Object}
   */
  mapPhysicalEntity: function (entity) {
    entity.fullName = entity.first_name + " " + entity.last_name;
    entity.initials =
      entity.first_name.charAt(0).toUpperCase() +
      entity.last_name.charAt(0).toUpperCase();

    return _.mapKeys(entity, (value, key) => _.camelCase(key));
  },
};

export default physicalEntityMapper;
